import React, {Component} from "react";
import _ from "i18n";

export default class FeedMangoModalFooter extends Component {

  constructor(props) {
    super(props);
  }

  handlePreviousClick = () => {
    this.props.changeStep(this.props.step - 1);
  }

  handleNextClick = () =>{
    this.props.changeStep(this.props.step + 1);
  }


  render() {

    const {step, amount, payinType, tag} = this.props;

    if(step === -1)
      return(
        <div className={'flex'}>
          <button type={'button'}
                  className="partial-credit-note-cancel-button"
                  onClick={this.handleNextClick} style={{'width': '100px'}}>{_("previous")}</button>
        </div>
      );

    if(payinType === "CARD")
      return(
        <div className={'flex'}>
          <button type={'button'}
                  className="partial-credit-note-cancel-button"
                  onClick={this.handlePreviousClick}
                  style={{'width': '100px'}}>{_("previous")}</button>
          {
            step === 1 &&
            <button type={'button'}
                    className="partial-credit-note-save-button ml-auto"
                    onClick={this.handleNextClick} style={{'width': '100px'}}
                    disabled={!amount}>{_("next")}</button>
          }
        </div>
      );


    return (
      <div className={'flex'}>
        {
          (step === 1 || step === 2) &&
          <button type={'button'}
                  className="partial-credit-note-cancel-button"
                  onClick={this.handlePreviousClick}
                  style={{'width': '100px'}}>{_("previous")}</button>
        }
        {
          step === 1 &&
          <button type={'button'}
                  className="partial-credit-note-save-button ml-auto"
                  onClick={this.handleNextClick} style={{'width': '100px'}}
                  disabled={!amount}>{_("next")}</button>
        }
        {
          step === 2 &&
          <button type={'button'}
                  className="partial-credit-note-save-button ml-auto"
                  onClick={this.handleNextClick} style={{'width': '100px'}}
                  disabled={!tag}>{_("next")}</button>
        }
      </div>
    );
  }

}





// WEBPACK FOOTER //
// ./app/components/Admin/FeedMangoWallet/FeedMangoModalFooter.js